var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "member-uid-header" },
    [
      _vm._t("default"),
      _c(
        "span",
        { staticClass: "kv" },
        [
          _c("span", { staticClass: "k" }, [_vm._v("会员账号 ")]),
          _c("span", { staticClass: "v" }, [
            _vm._v(_vm._s(_vm.username || "--")),
          ]),
          _c("el-button", {
            staticClass: "copy-btn",
            attrs: {
              type: "text",
              icon: "el-icon-copy-document",
              border: "none",
              size: "mini",
            },
            on: {
              click: function ($event) {
                return _vm.copyText(_vm.username)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "kv" },
        [
          _c("span", { staticClass: "k" }, [_vm._v("会员ID ")]),
          _c("span", { staticClass: "v" }, [
            _vm._v(_vm._s(_vm.uid != null && _vm.uid !== "" ? _vm.uid : "--")),
          ]),
          _c("el-button", {
            staticClass: "copy-btn",
            attrs: {
              type: "text",
              icon: "el-icon-copy-document",
              size: "mini",
            },
            on: {
              click: function ($event) {
                _vm.copyText(String(_vm.uid ?? ""))
              },
            },
          }),
        ],
        1
      ),
      _c("span", { staticClass: "kv" }, [
        _c("span", { staticClass: "k" }, [_vm._v("会员等级 ")]),
        _c(
          "span",
          { staticClass: "v" },
          [
            _c("el-tag", { attrs: { size: "mini", type: "warning" } }, [
              _vm._v(
                _vm._s(
                  _vm.vipLevel != null && _vm.vipLevel !== ""
                    ? `VIP${_vm.vipLevel}`
                    : "--"
                )
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }